import OAuthRedirect from './OAuthRedirect';

export default OAuthRedirect;
